import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { triangle } from 'polished';
import OpenArrow from './open-indicator';

const HoverMenuStyle = styled.li`
  display: inline-block;
  position: relative;
  padding: 0;
`;

const HoverMenuWrapper = styled.div`
  padding-top: 5px;
  position: absolute;
  left: -75px;
  z-index: 4;
`;

export const HoverMenuContainer = styled.div`
  padding: 0;
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  transform-style: flat;
  &:before {
    content: '';
    ${props => (props.pointOffset ? `left: ${props.pointOffset}` : '')};
    position: absolute;
    top: -4px;
    ${triangle({
      pointingDirection: 'top',
      width: '18px',
      height: '9px',
      foregroundColor: '#ddd'
    })};
  }
  &:after {
    content: '';
    ${props => (props.pointOffset ? `left: ${props.pointOffset}` : '')};
    position: absolute;
    top: -3px;
    ${triangle({
      pointingDirection: 'top',
      width: '18px',
      height: '9px',
      foregroundColor: 'white'
    })};
  }
`;

export default class HoverMenu extends Component {
  static propTypes = {
    menuItem: PropTypes.node,
    children: PropTypes.node,
    className: PropTypes.string,
    pointOffset: PropTypes.string,
    fancyArrow: PropTypes.bool
  };

  static defaultProps = {
    fancyArrow: false
  };

  state = {
    open: false
  };

  onMouseEnter = () => {
    this.setState({ open: true });
  };

  onMouseLeave = () => {
    this.setState({ open: false });
  };

  render() {
    const { menuItem, children, pointOffset, fancyArrow, ...props } = this.props;
    const { open } = this.state;
    return (
      <HoverMenuStyle onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} {...props}>
        {menuItem}
        {fancyArrow && <OpenArrow open={open} />}
        <HoverMenuWrapper style={{ display: open ? 'block' : 'none' }}>
          <HoverMenuContainer
            style={{ display: open ? 'block' : 'none' }}
            pointOffset={pointOffset}
          >
            {children}
          </HoverMenuContainer>
        </HoverMenuWrapper>
      </HoverMenuStyle>
    );
  }
}
